import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { CatalogProvider } from './context/CatalogContext'
import { ThemeProvider } from './context/ThemeContext'
import { ChangelogProvider } from './context/ChangelogContext'
import { SystemStatusProvider } from './context/SystemStatusContext'
import './styles/theme.css'
import './styles/custom.css'

const root = document.getElementById('root') as HTMLElement

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <ThemeProvider>
      <CatalogProvider>
        <ChangelogProvider>
          <SystemStatusProvider>
            <App />
          </SystemStatusProvider>
        </ChangelogProvider>
      </CatalogProvider>
    </ThemeProvider>
  </React.StrictMode>
)
